import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  getListFilters,
  getTotalListFilters,
  getPropertiesAction,
  REDUX_UPDATE_FILTERS,
  clearPropertiesAction,
  getCustomTags,
  getFullPropertiesAction,
  getListLocationsFilters,
  getListDynamicFilters,
  changeSelectedAction,
} from "../../redux/propertiesDucks"
import { useLocation } from "@reach/router"
import {
  getCustoms,
  getServices,
  getEnvironment,
  getGenerals,
  checkCurrentFilters,
  checkOperation,
  updateFilters,
  getView,
  updateRouter,
  loadFiltersRoute,
  getLocationCount,
  getTypeCount,
  getTagCount,
  getCustomTagCount,
  checkEnvironment,
  makeCustom,
  checkBedroom,
  getGrandfathers,
  getFathers,
  getChildrens,
  normalizeName,
} from "../../helpers/helper.filters"
import Loading from "../../components/Loading"
import { graphql, useStaticQuery } from "gatsby"

const Filter = ({
  _filters,
  listDynamicFilters,
  polygonCoordinates,
  loading_dynamic,
  listLocationLite,
  allLocations,
  loading,
  tokko_filters,
  total_tokko_filters,
  orders,
  api_key,
  totalCount,
  custom_tags,
  listLocationFilters,
  loading_locations,
  totalCountAlquilerTemporario,
  totalCountAlquiler,
  totalCountVenta,
  offset,
  dispatch,
  menu,
  setMenu,
}) => {
  const {
    realEstate: {
      template_version,
      design: { icons },
      proFeatures,
    },
  } = useStaticQuery(graphql`
    query {
      realEstate {
        template_version
        proFeatures {
          lowPrice
          mapView
          locationsAdv
        }
        design {
          icons
        }
      }
    }
  `)
  const MediaPro = template_version === "PRO" ? true : false
  const { lowPrice, mapView, locationsAdv } = proFeatures

  const history = useLocation()
  const pricesDefault = [
    20000, 40000, 60000, 80000, 100000, 200000, 400000, 600000, 800000, 1000000,
  ]
  const [helpers, setHelpers] = useState({
    minprice: 0,
    maxprice: 0,
    minarea: 0,
    maxarea: 0,
  }) // minprice,maxprice,minarea,maxarea
  const [location, setLocation] = useState(history.pathname.split("/"))
  const [filtersLoading, setFiltersLoading] = useState(true)
  const [environments, setEnvironments] = useState({ min: "", max: "" })
  const [bedrooms, setBedrooms] = useState({ min: "", max: "" })
  const [openMinEnvironment, setOpenMinEnvironment] = useState(false)
  const [openMaxEnvironment, setOpenMaxEnvironment] = useState(false)
  const [openMinBedrooms, setOpenMinBedrooms] = useState(false)
  const [openMaxBedrooms, setOpenMaxBedrooms] = useState(false)

  const [auxiliarValuesPrice, setAuxiliarPrice] = useState({
    priceType: "",
    priceMin: "",
    priceMax: "",
  })
  const [auxiliarValuesSurface, setAuxiliarSurface] = useState({
    surfaceType: "",
    surfaceMin: "",
    surfaceMax: "",
  })

  //Current Filter Array
  const [filters, setFilters] = useState({
    location: [],
    type: [],
    operation: getView(history),
    environments: "",
    bedrooms: "",
    age: "",
    producer_id: "",
    price: {
      is_off: false,
      type: "",
      priceMin: "",
      priceMax: "",
    },
    surface: {
      type: "",
      surfaceMin: "",
      surfaceMax: "",
    },
    environments_types: [],
    generals: [],
    services: [],
    specials: [],
  })

  useEffect(() => {
    // Ejecuto la accion para obtener los filtros
    if (total_tokko_filters.data && allLocations?.objects) {
      if (location) {
        loadFiltersRoute(
          location,
          setFilters,
          filters,
          total_tokko_filters.data,
          [],
          setFiltersLoading,
          allLocations,
          listLocationLite
        )
      }
    } else {
      if (api_key) {
        dispatch(getTotalListFilters())
        // dispatch(getCustomTags())
      }
    }
  }, [total_tokko_filters, api_key, allLocations])

  useEffect(() => {
    // Cada vez que cambia un filtro, actualizo el almacen de redux
    console.log(filtersLoading)
    console.log(allLocations)
    if (!filtersLoading) {
      if (api_key) {
        dispatch(REDUX_UPDATE_FILTERS(filters))
        dispatch(clearPropertiesAction())
        updateRouter(filters)
        dispatch(getPropertiesAction())
        // dispatch(getFullPropertiesAction())
        dispatch(getListFilters())
        dispatch(getListLocationsFilters())
        dispatch(getListDynamicFilters())
        setEnvironments(checkEnvironments())
        setBedrooms(checkBedrooms())
        if (checkCurrentFilters(filters, "surface-type", "total")) {
          setAuxiliarSurface({
            ...auxiliarValuesSurface,
            surfaceType: "total",
            surfaceMin: filters.surface.surfaceMin,
            surfaceMax: filters.surface.surfaceMax,
          })
        }
        if (checkCurrentFilters(filters, "surface-type", "cubierta")) {
          setAuxiliarSurface({
            ...auxiliarValuesSurface,
            surfaceType: "cubierta",
            surfaceMin: filters.surface.surfaceMin,
            surfaceMax: filters.surface.surfaceMax,
          })
        }
        if (checkCurrentFilters(filters, "price-type", "pesos")) {
          setAuxiliarPrice({
            ...auxiliarValuesPrice,
            priceType: "pesos",
            priceMin: filters.price.priceMin,
            priceMax: filters.price.priceMax,
          })
        }
        if (checkCurrentFilters(filters, "price-type", "dolares")) {
          setAuxiliarPrice({
            ...auxiliarValuesPrice,
            priceType: "dolares",
            priceMin: filters.price.priceMin,
            priceMax: filters.price.priceMax,
          })
        }
      }
    }
  }, [filters, orders, filtersLoading, api_key, polygonCoordinates])

  useEffect(() => {
    let interval = ""
    if (filters.environments !== `${environments.min}-${environments.max}`) {
      if (environments.min || environments.max) {
        if (environments.min !== "" || environments.max !== "") {
          interval = `${environments.min}-${environments.max}`
        }
        if (environments.min !== "" && environments.max === "") {
          interval = `${environments.min}-99`
        }
        if (environments.max !== "" && environments.min === "") {
          interval = `0-` + environments.max
        }
        return updateFilters(setFilters, filters, "environments", interval)
      }
    }
  }, [environments])

  useEffect(() => {
    let interval = ""
    if (filters.bedrooms !== `${bedrooms.min}-${bedrooms.max}`) {
      if (bedrooms.min || bedrooms.max) {
        if (bedrooms.min !== "" && bedrooms.max !== "") {
          interval = `${bedrooms.min}-${bedrooms.max}`
        }
        if (bedrooms.min !== "" && bedrooms.max === "") {
          interval = `${bedrooms.min}-99`
        }
        if (bedrooms.max !== "" && bedrooms.min === "") {
          interval = `0-` + bedrooms.max
        }
        return updateFilters(setFilters, filters, "bedrooms", interval)
      }
    }
  }, [bedrooms])

  useEffect(() => {
    if (!filtersLoading) {
      if (api_key) {
        dispatch(REDUX_UPDATE_FILTERS(filters))
        dispatch(clearPropertiesAction())
        updateRouter(filters)
        // // dispatch(getPropertiesAction())
        // dispatch(getFullPropertiesAction())
        dispatch(getListFilters())
        dispatch(getListLocationsFilters())
        dispatch(getListDynamicFilters())
        if (checkCurrentFilters(filters, "surface-type", "total")) {
          setAuxiliarSurface({
            ...auxiliarValuesSurface,
            surfaceType: "total",
            surfaceMin: filters.surface.surfaceMin,
            surfaceMax: filters.surface.surfaceMax,
          })
        }
        if (checkCurrentFilters(filters, "surface-type", "cubierta")) {
          setAuxiliarSurface({
            ...auxiliarValuesSurface,
            surfaceType: "cubierta",
            surfaceMin: filters.surface.surfaceMin,
            surfaceMax: filters.surface.surfaceMax,
          })
        }
        if (checkCurrentFilters(filters, "price-type", "pesos")) {
          setAuxiliarPrice({
            ...auxiliarValuesPrice,
            priceType: "pesos",
            priceMin: filters.price.priceMin,
            priceMax: filters.price.priceMax,
          })
        }
        if (checkCurrentFilters(filters, "price-type", "dolares")) {
          setAuxiliarPrice({
            ...auxiliarValuesPrice,
            priceType: "dolares",
            priceMin: filters.price.priceMin,
            priceMax: filters.price.priceMax,
          })
        }
      }
    }
  }, [api_key])

  useEffect(() => {
    if (filters.surface.type === "") {
      setAuxiliarSurface({
        surfaceType: "",
        surfaceMin: "",
        surfaceMax: "",
      })
    }
    if (filters.price.type === "") {
      setAuxiliarPrice({
        priceType: "",
        priceMin: "",
        priceMax: "",
      })
    }
  }, [filters.surface.type, filters.price.type])

  useEffect(() => {
    if (_filters.operation && _filters !== filters && checkContent(filters)) {
      setFilters(_filters)
    }
    dispatch(changeSelectedAction(0))
  }, [_filters, offset])

  const checkContent = filters => {
    const prot_filter = {
      location: [],
      type: [],
      operation: "",
      environments: "",
      bedrooms: "",
      price: {
        type: "",
        priceMin: "",
        priceMax: "",
      },
      surface: {
        type: "",
        surfaceMin: "",
        surfaceMax: "",
      },
      environments_types: [],
      generals: [],
      services: [],
      specials: [],
    }
    if (filters === prot_filter) {
      return false
    }
    return true
  }

  const sendAuxiliar = () => {
    updateFilters(
      setFilters,
      filters,
      "price-type",
      auxiliarValuesPrice.priceType
    )
    updateFilters(
      setFilters,
      filters,
      "price-min",
      auxiliarValuesPrice.priceMin
    )
    updateFilters(
      setFilters,
      filters,
      "price-max",
      auxiliarValuesPrice.priceMax
    )
    updateFilters(
      setFilters,
      filters,
      "surface-type",
      auxiliarValuesSurface.surfaceType
    )
    updateFilters(
      setFilters,
      filters,
      "surface-min",
      auxiliarValuesSurface.surfaceMin
    )
    updateFilters(
      setFilters,
      filters,
      "surface-max",
      auxiliarValuesSurface.surfaceMax
    )
  }

  const checkEnvironments = () => {
    const [min, max] =
      filters.environments !== "" ? filters.environments.split("-") : [0, 0]
    return { min, max }
  }

  const checkBedrooms = () => {
    const [min, max] =
      filters.bedrooms !== "" ? filters.bedrooms.split("-") : [0, 0]
    return { min, max }
  }

  const updateEnvironment = (type, value) => {
    if (type === "min") {
      return setEnvironments({ ...environments, min: value })
    }
    if (type === "max") {
      return setEnvironments({ ...environments, max: value })
    }
  }

  const updateBedroom = (type, value) => {
    if (type === "min") {
      return setBedrooms({ ...bedrooms, min: value })
    }
    if (type === "max") {
      return setBedrooms({ ...bedrooms, max: value })
    }
  }

  const checkCitiesActive = parent => {
    // // Se fija si todos los hijos de un padre estan activos
    if (Object.keys(parent[1]).length === 2) {
      if (
        filters.location.find(
          location => location?.id?.toString() === parent[1]?.id?.toString()
        )
      ) {
        return true
      }
      return false
    }
    for (const children of getChildrens(parent)) {
      if (filters.location.find(element => element.id === children[1].id)) {
      } else {
        return false
      }
    }
    return true
  }

  const updateLocationByParent = item => {
    let newLocations = filters.location
    for (let i = 0; i < getGrandfathers(allLocations).length; i++) {
      // Me fijo si el abuelo tiene todos los hijos activos, los desactivo y activo solo este padre que estoy clickeando.
      if (
        getFathers(getGrandfathers(allLocations)[i]).find(
          element => element[0] === item[0]
        )
      ) {
        if (checkAllFatherActives(getGrandfathers(allLocations)[i])) {
          //Si llegan a estar todos los hijos activos, los desactivo y dejo solo este activo.
          for (
            let j = 0;
            j < getFathers(getGrandfathers(allLocations)[i]).length;
            j++
          ) {
            // Recorro todos los "Hermanos" de este padre
            const brother = getFathers(getGrandfathers(allLocations)[i])[j]
            for (let c = 0; c < getChildrens(brother).length; c++) {
              // Recorro los hijos de los hermanos y tambien los deshabilito.
              let children = getChildrens(brother)[c]
              newLocations = newLocations.filter(
                location => location.id !== children[1].id
              )
            }
            newLocations = newLocations.filter(
              location => location.id !== brother[1].id
            ) //Saco todos los hermanos
          }
          if (getChildrens(item).length > 0) {
            for (let c = 0; c < getChildrens(item).length; c++) {
              newLocations = [
                ...newLocations,
                {
                  id: getChildrens(item)[c][1].id,
                  name: getChildrens(item)[c][0],
                },
              ]
            }
            return updateFilters(
              setFilters,
              filters,
              "allLocations",
              newLocations
            ) //Si este padre tiene hijos, los activo a ellos.
          }
          return updateFilters(setFilters, filters, "allLocations", [
            ...newLocations,
            { id: item[1].id, name: item[0] },
          ]) //Si este padre tiene hijos, los activo a ellos.
        }
      }
    }
    if (Object.keys(item[1]).length === 2) {
      // Si no tiene hijos el padre (CHEQUEAR ESTO)
      if (newLocations.find(element => element.id === item[1].id))
        return updateFilters(
          setFilters,
          filters,
          "allLocations",
          newLocations.filter(element => element.id !== item[1].id)
        )
      return updateFilters(setFilters, filters, "allLocations", [
        ...newLocations,
        { id: item[1].id, name: item[0] },
      ])
    }
    if (checkCitiesActive(item)) {
      // Si todos los hijos del padre están activos, los desactivo.
      for (const children of getChildrens(item)) {
        newLocations = newLocations.filter(
          element => element.id !== children[1].id
        )
      }
      return updateFilters(
        setFilters,
        filters,
        "allLocations",
        newLocations.filter(element => element.id !== item[1].id)
      ) //Si este padre tiene hijos, los activo a ellos.
    }
    for (const children of getChildrens(item)) {
      newLocations = newLocations.filter(
        element => element.id !== children[1].id
      )
      newLocations.push({ id: children[1].id, name: children[0] })
    }
    return updateFilters(setFilters, filters, "allLocations", [
      ...newLocations,
      { id: item[1].id, name: item[0] },
    ]) //Si este padre tiene hijos, los activo a ellos.
  }

  const updateLocationByChildren = item => {
    let newLocations = filters.location
    if (filters.location.find(element => element.id === item.id)) {
      return updateFilters(
        setFilters,
        filters,
        "allLocations",
        newLocations.filter(element => element.id !== item.id)
      )
    }
    return updateFilters(setFilters, filters, "allLocations", [
      ...newLocations,
      { id: item.id, name: item.name },
    ])
  }

  const updateLocationByGrandFather = item => {
    const parentFormated = getFathers(item).map(
      // Formateo todos los hijos de este abuelo.
      element => ({ id: element[1].id, name: element[0] })
    )
    let newLocations = []
    for (let i = 0; i < filters.location.length; i++) {
      //Recorro los filtros activos para eliminar todos los hijos de este abuelo activo.
      if (
        parentFormated.find(element => element.id === filters.location[i].id)
      ) {
        //Si encuentro un hijo activo, no lo agrego.
      } else {
        newLocations.push({
          id: filters.location[i].id,
          name: filters.location[i].name,
        }) //Mantengo los filtros activos que no pertenecer a este abuelo.
      }
    }
    if (!checkAllFatherActives(item)) {
      newLocations = [...newLocations, ...parentFormated] //Si no estan todos los hijos de este abuelo activos, los activo.
    } else {
      for (let i = 0; i < getFathers(item).length; i++) {
        const father = getFathers(item)[i]
        for (let c = 0; c < getChildrens(father).length; c++) {
          const children = getChildrens(father)[c]
          newLocations = newLocations.filter(
            element => element.id !== children[1].id
          ) // Elimino los nietos que estan activos.
        }
        //Axel acá tenes eliminar todos los "Nietos" activos que tiene este abuelo. REVISAR PORQUE NO FUNCIONA. ATENCION
      }
    }
    return updateFilters(setFilters, filters, "allLocations", newLocations)
  }

  const checkAllFatherActives = item => {
    // Se fija si todos los hijos de un abuelo estan activos
    for (const father of getFathers(item)) {
      if (filters.location.find(element => element.id === father[1].id)) {
      } else {
        return false
      }
    }
    return true
  }

  const checkNameActive = parent => {
    if (
      filters.location.find(
        element => element.name.toString() === parent[0].toString()
      )
    ) {
      return true
    }
    return false
  }

  function toMarkup(text, searcherOperation) {
    if (searcherOperation === "") {
      return text.toLowerCase()
    }
    text = text
      .toLowerCase()
      .replaceAll(
        searcherOperation.toLowerCase(),
        "<b>" + searcherOperation.toLowerCase() + "</b>"
      )
    return text
  }

  const checkResults = type => {
    if (type === "location") {
      for (let grandfather of getGrandfathers(allLocations)) {
        if (grandfather[0].toLowerCase().includes(searcher.toLowerCase())) {
          return false
        }
        for (let father of getFathers(grandfather)) {
          if (father[0].toLowerCase().includes(searcher.toLowerCase())) {
            return false
          }
          for (let children of getChildrens(father)) {
            if (children[0].toLowerCase().includes(searcher.toLowerCase())) {
              return false
            }
          }
        }
      }
      return true
    } else {
      for (let type of listFilters.data.objects.property_types) {
        if (type.type.toLowerCase().includes(searcherType.toLowerCase())) {
          return false
        }
      }
      return true
    }
  }

  const groupLocations = () => {
    if (!allLocations?.meta) {
      return []
    }
    const locations_grouped = []
    for (let grandfather of getGrandfathers(allLocations)) {
      if (checkAllFatherActives(grandfather)) {
        locations_grouped.push({ ...grandfather, is: "grandfather" })
      } else {
        for (let father of getFathers(grandfather)) {
          if (checkCitiesActive(father) || checkNameActive(father)) {
            // locations_grouped.push(father)
            locations_grouped.push({ ...father, is: "father" })
          } else {
            for (let children of getChildrens(father)) {
              if (
                filters.location.find(
                  element => element.name.toString() === children[0].toString()
                )
              ) {
                // locations_grouped.push(children)
                // locations_grouped.push(children)
                locations_grouped.push({ ...children, is: "children" })
              }
            }
          }
        }
      }
    }
    return locations_grouped
  }

  return tokko_filters.data &&
    total_tokko_filters.data &&
    listLocationFilters &&
    listDynamicFilters.data ? (
    <aside id="filters" className={"col-12 " + (menu ? " filterOn blur " : "")}>
      <form className="filters-container  filter-form container">
        <input type="hidden" name="page" value="1" />
        <div className="container-fluid">
          <div className="filters-header mt-3 d-flex flex-column justify-content-between align-items-start w-100">
            <div className="filter-border-bottom d-flex align-items-stretch justify-content-between w-100">
              <div className="end"></div>
              <div className="start d-lg-flex pt-lg-5 align-items-center justify-content-start">
                <div className="d-block">
                  <h2 className="me-lg-5">Filtros de búsqueda</h2>
                  {/* <h4 className="d-flex align-items-center">Filtros aplicados <div className="small">{loading ? 'Cargando..' : "(Mostrando " + totalCount + " resultados de " + (filters.operation.includes("venta") ? totalCountVenta : totalCountAlquiler) + " propiedades en " + filters.operation + ")"}</div></h4> */}
                </div>
              </div>
              <div id="closeFilter" className="end">
                <div
                  onClick={() =>
                    document.body.classList.remove("overflow-hidden") +
                    setMenu(false)
                  }
                  className="filters-close mt-2 text-right justify-content-right algin-items-start"
                  style={{ cursor: "pointer" }}
                >
                  <span className="d-block">
                    <i></i>
                    <i></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="current-filters w-100 mt-lg-4 mt-2 d-lg-flex align-items-center justify-content-between">
              <div>
                {
                  <div className="d-inline-block">
                    {
                      <div
                        className={
                          "tag tag-button d-inline-flex align-items-center justify-content-center " +
                          filters.operation.toLowerCase()
                        }
                      >
                        {filters.operation}
                      </div>
                    }
                  </div>
                }
                {!locationsAdv &&
                  filters.location.map((item, index) => (
                    <div className="d-inline-block">
                      {
                        <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                          {item.name}{" "}
                          <div
                            onClick={() =>
                              updateFilters(
                                setFilters,
                                filters,
                                "location",
                                item
                              )
                            }
                            className="btn-delete-tag cursor-pointer ms-3"
                          >
                            ×
                          </div>
                        </div>
                      }
                    </div>
                  ))}
                {locationsAdv &&
                  groupLocations().map((item, index) => (
                    <div className="d-inline-block">
                      {
                        <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                          {item[0]}{" "}
                          <div
                            onClick={() => updateLocationByGroup(item)}
                            className="btn-delete-tag cursor-pointer ms-1"
                          >
                            ×
                          </div>
                        </div>
                      }
                    </div>
                  ))}
                {/* {!locationsAdv && filters.location.map((item,index) =>(<div className="d-inline-block">{<div className="tag tag-button d-inline-flex align-items-center justify-content-center">{item.name} <div onClick={() =>  updateFilters(setFilters,filters,'location',item)} className="btn-delete-tag cursor-pointer ms-1">×</div></div>}</div>))} */}
                {filters.type.map((item, index) => (
                  <div className="d-inline-block">
                    {
                      <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                        {item.name}{" "}
                        <div
                          onClick={() =>
                            updateFilters(setFilters, filters, "type", item)
                          }
                          className="btn-delete-tag cursor-pointer ms-3"
                        >
                          ×
                        </div>
                      </div>
                    }
                  </div>
                ))}
                {filters.price.is_off === true ? (
                  <div className="d-inline-block">
                    {
                      <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                        Propiedades retasadas{" "}
                        <div
                          onClick={() =>
                            updateFilters(setFilters, filters, "is_off", "null")
                          }
                          className="btn-delete-tag cursor-pointer ms-3"
                        >
                          ×
                        </div>
                      </div>
                    }
                  </div>
                ) : (
                  ""
                )}
                {filters.price.type !== "" ? (
                  <div className="d-inline-block">
                    {
                      <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                        {filters.price.type}{" "}
                        <div
                          onClick={() =>
                            updateFilters(
                              setFilters,
                              filters,
                              "price-type",
                              "null"
                            )
                          }
                          className="btn-delete-tag cursor-pointer ms-3"
                        >
                          ×
                        </div>
                      </div>
                    }
                  </div>
                ) : (
                  ""
                )}
                {filters.price.type !== "" ? (
                  <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                    Desde: $ {filters.price.priceMin} Hasta: ${" "}
                    {filters.price.priceMax}{" "}
                    <div
                      onClick={() =>
                        updateFilters(setFilters, filters, "price-type", "null")
                      }
                      className="btn-delete-tag cursor-pointer ms-3"
                    >
                      ×
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {filters.surface.type !== "" ? (
                  <div className="d-inline-block">
                    {
                      <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                        {filters.surface.type}{" "}
                        <div
                          onClick={() =>
                            updateFilters(
                              setFilters,
                              filters,
                              "surface-type",
                              ""
                            )
                          }
                          className="btn-delete-tag cursor-pointer ms-3"
                        >
                          ×
                        </div>
                      </div>
                    }
                  </div>
                ) : (
                  ""
                )}
                {filters.surface.type !== "" ? (
                  <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                    Desde: {filters.surface.surfaceMin} M2 Hasta:{" "}
                    {filters.surface.surfaceMax} M2
                    <div
                      onClick={() =>
                        updateFilters(setFilters, filters, "surface-type", "")
                      }
                      className="btn-delete-tag cursor-pointer ms-3"
                    >
                      ×
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* {filters.environments.map((item,index) =>(<div className="d-inline-block">{<div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">{item} <div onClick={() =>  updateFilters(setFilters,filters,'environments',item)} className="btn-delete-tag cursor-pointer ms-3">×</div></div>}</div>))} */}
                {filters.environments !== "" ? (
                  <div className="tag tag-button d-inline-flex align-items-center justify-content-center not-capitalize">
                    {filters?.environments?.split("-")[0] ===
                    filters?.environments?.split("-")[1]
                      ? filters?.environments?.split("-")[0] !== "0" &&
                        (filters?.environments?.split("-")[0].toString() ===
                        "99"
                          ? "+9"
                          : filters?.environments?.split("-")[0]) + " amb"
                      : (filters?.environments?.split("-")[0] !== "0"
                          ? "Desde " + filters?.environments?.split("-")[0]
                          : "") +
                        (filters.environments.split("-")[1] !== "99" ||
                        filters.environments.split("-")[0] === "0"
                          ? " hasta " + filters.environments.split("-")[1]
                          : "") +
                        " amb"}
                    <div
                      onClick={() =>
                        updateFilters(setFilters, filters, "environments", "")
                      }
                      className="btn-delete-tag cursor-pointer ms-1"
                    >
                      ×
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {filters?.bedrooms !== "" ? (
                  <div className="tag tag-button d-inline-flex align-items-center justify-content-center not-capitalize">
                    {filters?.bedrooms?.split("-")[0] ===
                    filters?.bedrooms?.split("-")[1]
                      ? filters?.bedrooms?.split("-")[0] !== "0" &&
                        (filters?.bedrooms?.split("-")[0].toString() === "99"
                          ? "+9"
                          : filters?.bedrooms?.split("-")[0]) + " dorm"
                      : (filters?.bedrooms?.split("-")[0] !== "0"
                          ? "Desde " + filters?.bedrooms?.split("-")[0]
                          : "") +
                        (filters.bedrooms.split("-")[1] !== "99" ||
                        filters.bedrooms.split("-")[0] === "0"
                          ? " hasta " + filters.bedrooms.split("-")[1]
                          : "") +
                        " dorm"}
                    <div
                      onClick={() =>
                        updateFilters(setFilters, filters, "bedrooms", "")
                      }
                      className="btn-delete-tag cursor-pointer ms-1"
                    >
                      ×
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {filters.age !== "" && filters.age !== undefined ? (
                  <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                    {filters.age}{" "}
                    {filters?.age?.includes("años") ? " de antigüedad" : ""}
                    <div
                      onClick={() =>
                        updateFilters(setFilters, filters, "age", "")
                      }
                      className="btn-delete-tag cursor-pointer ms-3"
                    >
                      ×
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {filters.producer_id !== "" &&
                filters.producer_id !== undefined ? (
                  <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                    {filters.producer_id
                      .split("-")
                      .map((element, index) => index > 0 && element + " ")}
                    <div
                      onClick={() =>
                        updateFilters(setFilters, filters, "producer_id", "")
                      }
                      className="btn-delete-tag cursor-pointer ms-3"
                    >
                      ×
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* {filters.environments !== ''? (<div className="d-inline-block">{<div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">{filters.environments} <div onClick={() =>  updateFilters(setFilters,filters,'environments',filters.environments)} className="btn-delete-tag cursor-pointer ms-3">×</div></div>}</div>):''} */}
                {filters.environments_types.map((item, index) => (
                  <div className="d-inline-block">
                    {
                      <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                        {item.name}{" "}
                        <div
                          onClick={() =>
                            updateFilters(
                              setFilters,
                              filters,
                              "environments_types",
                              item
                            )
                          }
                          className="btn-delete-tag cursor-pointer ms-3"
                        >
                          ×
                        </div>
                      </div>
                    }
                  </div>
                ))}
                {filters.services.map((item, index) => (
                  <div className="d-inline-block">
                    {
                      <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                        {item.name}{" "}
                        <div
                          onClick={() =>
                            updateFilters(setFilters, filters, "services", item)
                          }
                          className="btn-delete-tag cursor-pointer ms-3"
                        >
                          ×
                        </div>
                      </div>
                    }
                  </div>
                ))}
                {filters.specials.map((item, index) => (
                  <div className="d-inline-block">
                    {
                      <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                        {item.name}{" "}
                        <div
                          onClick={() =>
                            updateFilters(
                              setFilters,
                              filters,
                              "specials",
                              makeCustom(item)
                            )
                          }
                          className="btn-delete-tag cursor-pointer ms-3"
                        >
                          ×
                        </div>
                      </div>
                    }
                  </div>
                ))}
                {filters.generals.map((item, index) => (
                  <div className="d-inline-block">
                    {
                      <div className="tag tag-button no-hover d-inline-flex align-items-center justify-content-center">
                        {item.name}{" "}
                        <div
                          onClick={() =>
                            updateFilters(setFilters, filters, "generals", item)
                          }
                          className="btn-delete-tag cursor-pointer ms-3"
                        >
                          ×
                        </div>
                      </div>
                    }
                  </div>
                ))}
              </div>
              <a
                className="btn btn-clean btn-blue cursor-pointer"
                onClick={() =>
                  setFilters(filters => ({
                    location: [],
                    type: [],
                    operation: location[1],
                    environments: "",
                    bedrooms: "",
                    price: {
                      type: "",
                      priceMin: 0,
                      priceMax: 50000000,
                    },
                    surface: {
                      type: "",
                      surfaceMin: 0,
                      surfaceMax: 10000,
                    },
                    environments_types: [],
                    generals: [],
                    services: [],
                    specials: [],
                  })) +
                  setAuxiliarPrice({
                    priceType: "",
                    priceMin: "",
                    priceMax: "",
                  }) +
                  setAuxiliarSurface({
                    surfaceType: "",
                    surfaceMin: "",
                    surfaceMax: "",
                  })
                }
              >
                Limpiar filtros
              </a>
            </div>
          </div>
          <div className="filters-group" id="operation">
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer  "
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-operation"
              aria-expanded="false"
              aria-controls="collapse-operation"
            >
              Tipo de operación<a className="icon-arrow text-right d-block"></a>
            </h3>
            <div className="options">
              <div className="row collapse show pb-4" id="collapse-operation">
                <div
                  className={
                    "col-lg-4 " +
                    (checkOperation(total_tokko_filters.data.objects, 1) ===
                    undefined
                      ? "d-none"
                      : "")
                  }
                >
                  <label className="option">
                    <input
                      onChange={() =>
                        updateFilters(setFilters, filters, "operation", "venta")
                      }
                      checked={checkCurrentFilters(
                        filters,
                        "operation",
                        "venta"
                      )}
                      type="radio"
                      id="o-venta"
                      name="operation"
                      value="1"
                    />
                    <span className="radio"></span>Venta ({totalCountVenta})
                  </label>
                </div>
                <div
                  className={
                    "col-lg-4 " +
                    (checkOperation(total_tokko_filters.data.objects, 2) ===
                    undefined
                      ? "d-none"
                      : "")
                  }
                >
                  <label className="option">
                    <input
                      onChange={() =>
                        updateFilters(
                          setFilters,
                          filters,
                          "operation",
                          "alquiler"
                        )
                      }
                      checked={checkCurrentFilters(
                        filters,
                        "operation",
                        "alquiler"
                      )}
                      type="radio"
                      id="o-alquiler"
                      name="operation"
                      value="2"
                    />
                    <span className="radio"></span>Alquiler (
                    {totalCountAlquiler})
                  </label>
                </div>
                <div
                  className={
                    "col-lg-4 " +
                    (checkOperation(total_tokko_filters.data.objects, 3) ===
                    undefined
                      ? "d-none"
                      : "")
                  }
                >
                  <label className="option">
                    <input
                      onChange={() =>
                        updateFilters(
                          setFilters,
                          filters,
                          "operation",
                          "alquiler-temporario"
                        )
                      }
                      checked={checkCurrentFilters(
                        filters,
                        "operation",
                        "alquiler-temporario"
                      )}
                      type="radio"
                      id="o-alquiler-temporario"
                      name="operation"
                      value="3"
                    />
                    <span className="radio"></span>Alquiler temporario (
                    {totalCountAlquilerTemporario})
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="filters-group" id="types">
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-types"
              aria-expanded="false"
              aria-controls="collapse-types"
            >
              Tipo de propiedad{" "}
              <a className="icon-arrow text-right d-block"></a>
            </h3>
            <div className="options">
              <div className="row collapse pb-4" id="collapse-types">
                {total_tokko_filters.data.objects.property_types.map(
                  (item, i) => (
                    <div
                      key={i}
                      className={
                        "col-lg-4 " +
                        (getTypeCount(tokko_filters.data.objects, item) === 0
                          ? "d-none"
                          : "")
                      }
                    >
                      <label
                        className={
                          "option " +
                          (getTypeCount(tokko_filters.data.objects, item) === 0
                            ? "d-none"
                            : "")
                        }
                      >
                        <input
                          type="checkbox"
                          onChange={() =>
                            updateFilters(setFilters, filters, "type", {
                              id: item.id,
                              name: item.type,
                            })
                          }
                          checked={checkCurrentFilters(
                            filters,
                            "type",
                            item.type
                          )}
                          id={"type " + item.id}
                          name="type"
                          value="none"
                        />
                        <span className="square"></span>
                        {item.type} (
                        {loading
                          ? "Cargando.."
                          : getTypeCount(tokko_filters.data.objects, item)}
                        )
                      </label>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
          <div className="filters-group" id="location">
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer  collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-location"
              aria-expanded="false"
              aria-controls="collapse-location"
            >
              Ubicación <a className="icon-arrow text-right d-block"></a>
            </h3>
            <div className="options">
              <div className="row collapse pb-4" id="collapse-location">
                {loading_locations || !listLocationFilters?.data ? (
                  <Loading />
                ) : locationsAdv ? (
                  getGrandfathers(allLocations).map(
                    (
                      item,
                      i // List the grandfathers
                    ) => (
                      <div className={""}>
                        <div className="d-flex mt-2 px-lg-3 w-100 align-items-center not-closer justify-content-start w-custom">
                          <div
                            className={
                              "me-2 open-collapse not-closer collapsed d-inline-flex"
                            }
                            data-bs-toggle="collapse"
                            data-bs-target={
                              "#collapse-location-" + normalizeName(item[0])
                            }
                            aria-expanded="false"
                            aria-controls={
                              "collapse-location-" + normalizeName(item[0])
                            }
                          >
                            <div className={"symbol not-closer"}></div>{" "}
                          </div>
                          <label
                            className={"mb-0 option flex-input not-closer"}
                          >
                            <input
                              onChange={() => updateLocationByGrandFather(item)}
                              checked={checkAllFatherActives(item)}
                              id=""
                              type="checkbox"
                              className="radio-custom not-closer "
                              name="location[]"
                              value={item[0]}
                            />
                            <span className="custom-input not-closer square"></span>{" "}
                            {item[0].replace("**(.*)**", "<b>$1</b>")}
                          </label>
                        </div>
                        <div
                          className="detail-collapse not-height collapse not-closer "
                          id={"collapse-location-" + normalizeName(item[0])}
                        >
                          {getFathers(item).map(
                            (
                              father // List the fathers
                            ) => (
                              <div className="d-flex flex-column justify-content-content mb-0 align-items-start not-closer w-custom childrens">
                                <div className="d-flex align-items-center w-100 justify-content-center not-closer ">
                                  <div
                                    className={
                                      "me-2 not-closer open-collapse collapsed d-inline-flex " +
                                      (getChildrens(father).length <= 1
                                        ? " opacity "
                                        : "")
                                    }
                                    data-bs-toggle="collapse"
                                    data-bs-target={
                                      "#collapse-location-" +
                                      normalizeName(father[0])
                                    }
                                    aria-expanded="false"
                                    aria-controls={
                                      "collapse-location-" +
                                      normalizeName(father[0])
                                    }
                                  >
                                    <div className={"symbol not-closer"}></div>{" "}
                                  </div>
                                  <label
                                    className={
                                      "option mb-1 not-closer flex-input"
                                    }
                                  >
                                    {/* +  updateFilters(setFilters,filters,"location", {id:father[1].id,name:father[0]}) */}
                                    <input
                                      onChange={() =>
                                        updateLocationByParent(father)
                                      }
                                      checked={
                                        checkCitiesActive(father) &&
                                        !checkAllFatherActives(item)
                                      }
                                      type="checkbox"
                                      className="not-closer radio-custom"
                                      name="location[]"
                                      value={father[0]}
                                    />
                                    <span className="not-closer custom-input square my-0"></span>{" "}
                                    {father[0]}
                                  </label>
                                </div>
                                <div
                                  className="detail-collapse children not-height collapse not-closer mb-2 childrens"
                                  id={
                                    "collapse-location-" +
                                    normalizeName(father[0])
                                  }
                                >
                                  {getChildrens(father).map(
                                    (
                                      children // List the childrens
                                    ) => (
                                      <label
                                        className={
                                          "not-closer mb-1 option flex-input"
                                        }
                                      >
                                        <input
                                          id=""
                                          type="checkbox"
                                          checked={
                                            filters.location.find(
                                              element =>
                                                element.id === children[1].id
                                            ) && !checkAllFatherActives(item)
                                          }
                                          onChange={() =>
                                            updateLocationByChildren({
                                              id: children[1].id,
                                              name: children[0],
                                            })
                                          }
                                          className="not-closer radio-custom"
                                          name="location[]"
                                          value={children[0]}
                                        />
                                        <span className="not-closer  custom-input square my-0"></span>{" "}
                                        {children[0]}
                                      </label>
                                    )
                                  )}
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )
                  )
                ) : (
                  listLocationFilters.data.objects.locations.map((item, i) => (
                    <div
                      className={
                        "col-lg-4 " +
                        (getLocationCount(
                          listLocationFilters.data.objects,
                          item
                        ) === 0
                          ? "d-none"
                          : "")
                      }
                    >
                      <label
                        className={
                          "option " +
                          (getLocationCount(
                            listLocationFilters.data.objects,
                            item
                          ) === 0
                            ? "opacity-filter"
                            : "")
                        }
                      >
                        <input
                          id=""
                          onChange={() =>
                            updateFilters(setFilters, filters, "location", {
                              id: item.location_id,
                              name: item.location_name,
                            })
                          }
                          checked={checkCurrentFilters(
                            filters,
                            "location",
                            item.location_name
                          )}
                          type="checkbox"
                          className="radio-custom"
                          name="location[]"
                          value={item.location_id}
                        />
                        <span className="square"></span> {item.location_name}
                      </label>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          <div
            className={
              "filters-group " +
              (listDynamicFilters.data.objects.room_amount.filter(
                element => element.amount !== 0
              ).length === 0
                ? " d-none "
                : "")
            }
            id="environments"
          >
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer  collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-amb"
              aria-expanded="false"
              aria-controls="collapse-amb"
            >
              Ambientes | Dormitorios{" "}
              <a className="icon-arrow text-right d-block"></a>
            </h3>
            <div className="ps-4 ps-lg-0 pe-5 pe-lg-5">
              <div className="row collapse pb-4" id="collapse-amb">
                <div className="col-lg-6">
                  <h5 className="mb-lg-3 ps-lg-4 ms-2">Ambientes</h5>
                  <div className="d-flex ms-2">
                    <div
                      className={
                        "d-block content-field not-closer px-lg-4 pe-3 pe-lg-4 " +
                        (!openMinEnvironment && "close")
                      }
                    >
                      <div
                        className={
                          "d-lg-flex dropdown-select btn btn-main no-hover not-closer me-2 "
                        }
                        onClick={() =>
                          setOpenMinEnvironment(!openMinEnvironment)
                        }
                      >
                        <span className="">
                          {environments.min === ""
                            ? "Minimo"
                            : (environments.min.toString() === "99"
                                ? "+9"
                                : environments.min) + " amb"}
                        </span>
                        <i className="icon-arrow-light not-closer"></i>
                      </div>
                      <div
                        className={
                          "w-auto not-closer float-select position-relative "
                        }
                      >
                        <div
                          className={
                            "not-closer flex-input px-0 " +
                            (!checkEnvironment(
                              listDynamicFilters.data.objects,
                              1
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("min", 1)}
                            checked={environments.min.toString() === "1"}
                            type="radio"
                            id="amb-filter-1-min"
                            name="roomsMin"
                            value="1"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().min === 1 ? "active" : "")
                            }
                            htmlFor={"amb-filter-1-min"}
                          >
                            <div className="custom-span not-closer"></div>1 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkEnvironment(
                              listDynamicFilters.data.objects,
                              2
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("min", 2)}
                            checked={environments.min.toString() === "2"}
                            type="radio"
                            id="amb-filter-2-min"
                            name="roomsMin"
                            value="2"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().min === 2 ? "active" : "")
                            }
                            htmlFor={"amb-filter-2-min"}
                          >
                            <div className="custom-span not-closer"></div>2 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkEnvironment(
                              listDynamicFilters.data.objects,
                              3
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("min", 3)}
                            checked={environments.min.toString() === "3"}
                            type="radio"
                            id="amb-filter-3-min"
                            name="roomsMin"
                            value="3"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().min === 3 ? "active" : "")
                            }
                            htmlFor={"amb-filter-3-min"}
                          >
                            <div className="custom-span not-closer"></div>3 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkEnvironment(
                              listDynamicFilters.data.objects,
                              4
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("min", 4)}
                            checked={environments.min.toString() === "4"}
                            type="radio"
                            id="amb-filter-4-min"
                            name="roomsMin"
                            value="4"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().min === 4 ? "active" : "")
                            }
                            htmlFor={"amb-filter-4-min"}
                          >
                            <div className="custom-span not-closer"></div>4 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkEnvironment(
                              listDynamicFilters.data.objects,
                              5
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("min", 5)}
                            checked={environments.min.toString() === "5"}
                            type="radio"
                            id="amb-filter-5-min"
                            name="roomsMin"
                            value="5"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().min === 5 ? "active" : "")
                            }
                            htmlFor={"amb-filter-5-min"}
                          >
                            <div className="custom-span not-closer"></div>5 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkEnvironment(
                              listDynamicFilters.data.objects,
                              6
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("min", 6)}
                            checked={environments.min.toString() === "6"}
                            type="radio"
                            id="amb-filter-6-min"
                            name="roomsMin"
                            value="6"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().min === 6 ? "active" : "")
                            }
                            htmlFor={"amb-filter-6-min"}
                          >
                            <div className="custom-span not-closer"></div>6 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkEnvironment(
                              listDynamicFilters.data.objects,
                              7
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("min", 7)}
                            checked={environments.min.toString() === "7"}
                            type="radio"
                            id="amb-filter-7-min"
                            name="roomsMin"
                            value="7"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().min === 7 ? "active" : "")
                            }
                            htmlFor={"amb-filter-7-min"}
                          >
                            <div className="custom-span not-closer"></div>7 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkEnvironment(
                              listDynamicFilters.data.objects,
                              8
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("min", 8)}
                            checked={environments.min.toString() === "8"}
                            type="radio"
                            id="amb-filter-8-min"
                            name="roomsMin"
                            value="8"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().min === 8 ? "active" : "")
                            }
                            htmlFor={"amb-filter-8-min"}
                          >
                            <div className="custom-span not-closer"></div>8 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkEnvironment(
                              listDynamicFilters.data.objects,
                              9
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("min", 9)}
                            checked={environments.min.toString() === "9"}
                            type="radio"
                            id="amb-filter-9-min"
                            name="roomsMin"
                            value="9"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().min === 9 ? "active" : "")
                            }
                            htmlFor={"amb-filter-9-min"}
                          >
                            <div className="custom-span not-closer"></div>+9 amb
                          </label>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        "d-block content-field not-closer px-lg-4 pe-3 pe-lg-4 " +
                        (!openMaxEnvironment && "close")
                      }
                    >
                      {/* //Max */}
                      <div
                        className={"d-lg-block not-closer "}
                        onClick={() =>
                          setOpenMaxEnvironment(!openMaxEnvironment)
                        }
                      >
                        <span className="d-lg-flex dropdown-select btn btn-main no-hover not-closer me-2 ">
                          {environments.max === ""
                            ? "Máximo"
                            : (environments.max.toString() === "99"
                                ? "+9"
                                : environments.max.toString()) + " amb"}
                          <i className="icon-arrow-light not-closer"></i>
                        </span>
                      </div>
                      <div className="w-auto not-closer float-select position-relative">
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkEnvironment(
                              listDynamicFilters.data.objects,
                              1
                            ) ||
                              environments.min > 1) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("max", 1)}
                            checked={environments.max.toString() === "1"}
                            type="radio"
                            id="amb-filter-1-max"
                            name="roomsMax"
                            value="1"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().max === 1 ? "active" : "")
                            }
                            htmlFor={"amb-filter-1-max"}
                          >
                            <div className="custom-span not-closer"></div>1 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkEnvironment(
                              listDynamicFilters.data.objects,
                              2
                            ) ||
                              environments.min > 2) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("max", 2)}
                            checked={environments.max.toString() === "2"}
                            type="radio"
                            id="amb-filter-2-max"
                            name="roomsMax"
                            value="2"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().max === 1 ? "active" : "")
                            }
                            htmlFor={"amb-filter-2-max"}
                          >
                            <div className="custom-span not-closer"></div>2 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkEnvironment(
                              listDynamicFilters.data.objects,
                              3
                            ) ||
                              environments.min > 3) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("max", 3)}
                            checked={environments.max.toString() === "3"}
                            type="radio"
                            id="amb-filter-3-max"
                            name="roomsMax"
                            value="3"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().max === 3 ? "active" : "")
                            }
                            htmlFor={"amb-filter-3-max"}
                          >
                            <div className="custom-span not-closer"></div>3 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkEnvironment(
                              listDynamicFilters.data.objects,
                              4
                            ) ||
                              environments.min > 4) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("max", 4)}
                            checked={environments.max.toString() === "4"}
                            type="radio"
                            id="amb-filter-4-max"
                            name="roomsMax"
                            value="4"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().max === 4 ? "active" : "")
                            }
                            htmlFor={"amb-filter-4-max"}
                          >
                            <div className="custom-span not-closer"></div>4 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkEnvironment(
                              listDynamicFilters.data.objects,
                              5
                            ) ||
                              environments.min > 5) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("max", 5)}
                            checked={environments.max.toString() === "5"}
                            type="radio"
                            id="amb-filter-5-max"
                            name="roomsMax"
                            value="5"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().max === 5 ? "active" : "")
                            }
                            htmlFor={"amb-filter-5-max"}
                          >
                            <div className="custom-span not-closer"></div>5 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkEnvironment(
                              listDynamicFilters.data.objects,
                              6
                            ) ||
                              environments.min > 6) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("max", 6)}
                            checked={environments.max.toString() === "6"}
                            type="radio"
                            id="amb-filter-6-max"
                            name="roomsMax"
                            value="6"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().max === 6 ? "active" : "")
                            }
                            htmlFor={"amb-filter-6-max"}
                          >
                            <div className="custom-span not-closer"></div>6 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkEnvironment(
                              listDynamicFilters.data.objects,
                              7
                            ) ||
                              environments.min > 7) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("max", 7)}
                            checked={environments.max.toString() === "7"}
                            type="radio"
                            id="amb-filter-7-max"
                            name="roomsMax"
                            value="7"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().max === 7 ? "active" : "")
                            }
                            htmlFor={"amb-filter-7-max"}
                          >
                            <div className="custom-span not-closer"></div>7 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkEnvironment(
                              listDynamicFilters.data.objects,
                              8
                            ) ||
                              environments.min > 8) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("max", 8)}
                            checked={environments.max.toString() === "8"}
                            type="radio"
                            id="amb-filter-8-max"
                            name="roomsMax"
                            value="8"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().max === 8 ? "active" : "")
                            }
                            htmlFor={"amb-filter-8-max"}
                          >
                            <div className="custom-span not-closer"></div>8 amb
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkEnvironment(
                              listDynamicFilters.data.objects,
                              9
                            ) ||
                              environments.min > 9) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment("max", 9)}
                            checked={environments.max.toString() === "9"}
                            type="radio"
                            id="amb-9-max"
                            name="roomsMax"
                            value="9"
                          />
                          <label
                            className={
                              "not-closer " +
                              (checkEnvironments().max === 9 ? "active" : "")
                            }
                            htmlFor={"amb-9-max"}
                          >
                            <div className="custom-span not-closer"></div>+9 amb
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <h5 className="mb-lg-3 ps-lg-4 ms-2">Dormitorios</h5>
                  <div className="d-flex ms-2">
                    <div
                      className={
                        "d-block content-field not-closer px-lg-4 pe-3 pe-lg-4 " +
                        (!openMinBedrooms && "close")
                      }
                    >
                      <div
                        onClick={() => setOpenMinBedrooms(!openMinBedrooms)}
                        className="not-closer dropdown-select minimal-select btn btn-main no-hover justify-content-between"
                      >
                        {bedrooms.min === ""
                          ? "Minimo"
                          : (bedrooms.min.toString() === "99"
                              ? "+9"
                              : bedrooms.min) + " dorm"}
                        <i className="icon-arrow-light not-closer"></i>
                      </div>
                      <div className="w-auto not-closer float-select position-relative">
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkBedroom(
                              listDynamicFilters.data.objects,
                              1
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom("min", 1)}
                            checked={bedrooms.min.toString() === "1"}
                            type="radio"
                            id="bed-filter-1"
                            name="bedMin"
                            value="1"
                          />
                          <label
                            className="not-closer"
                            htmlFor={"bed-filter-1"}
                          >
                            <div className="custom-span not-closer"></div>1 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkBedroom(
                              listDynamicFilters.data.objects,
                              2
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom("min", 2)}
                            checked={bedrooms.min.toString() === "2"}
                            type="radio"
                            id="bed-filter-2-min"
                            name="bedMin"
                            value="2"
                          />
                          <label
                            className="not-closer"
                            htmlFor={"bed-filter-2-min"}
                          >
                            <div className="custom-span not-closer"></div>2 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkBedroom(
                              listDynamicFilters.data.objects,
                              3
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom("min", 3)}
                            checked={bedrooms.min.toString() === "3"}
                            type="radio"
                            id="bed-filter-3-min"
                            name="bedMin"
                            value="3"
                          />
                          <label
                            className="not-closer"
                            htmlFor={"bed-filter-3-min"}
                          >
                            <div className="custom-span not-closer"></div>3 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkBedroom(
                              listDynamicFilters.data.objects,
                              4
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom("min", 4)}
                            checked={bedrooms.min.toString() === "4"}
                            type="radio"
                            id="bed-filter-4-min"
                            name="bedMin"
                            value="4"
                          />
                          <label
                            className="not-closer"
                            htmlFor={"bed-filter-4-min"}
                          >
                            <div className="custom-span not-closer"></div>4 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkBedroom(
                              listDynamicFilters.data.objects,
                              5
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom("min", 5)}
                            checked={bedrooms.min.toString() === "5"}
                            type="radio"
                            id="bed-filter-5-min"
                            name="bedMin"
                            value="5"
                          />
                          <label
                            className="not-closer"
                            htmlFor={"bed-filter-5-min"}
                          >
                            <div className="custom-span not-closer"></div>5 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkBedroom(
                              listDynamicFilters.data.objects,
                              6
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom("min", 6)}
                            checked={bedrooms.min.toString() === "6"}
                            id="bed-filter-6-min"
                            name="bedMin"
                            value="6"
                          />
                          <label
                            className="not-closer"
                            htmlFor={"bed-filter-6-min"}
                          >
                            <div className="custom-span not-closer"></div>6 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkBedroom(
                              listDynamicFilters.data.objects,
                              7
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom("min", 7)}
                            checked={bedrooms.min.toString() === "7"}
                            id="bed-filter-7-min"
                            name="bedMin"
                            value="7"
                          />
                          <label
                            className="not-closer"
                            htmlFor={"bed-filter-7-min"}
                          >
                            <div className="custom-span not-closer"></div>7 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkBedroom(
                              listDynamicFilters.data.objects,
                              8
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom("min", 8)}
                            checked={bedrooms.min.toString() === "8"}
                            id="bed-filter-8-min"
                            name="bedMin"
                            value="8"
                          />
                          <label
                            className="not-closer"
                            htmlFor={"bed-filter-8-min"}
                          >
                            <div className="custom-span not-closer"></div>8 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            (!checkBedroom(
                              listDynamicFilters.data.objects,
                              9
                            ) && "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom("min", 99)}
                            checked={bedrooms.min.toString() === "99"}
                            id="bed-9-min"
                            name="bedMin"
                            value="9"
                          />
                          <label className="not-closer" htmlFor={"bed-9-min"}>
                            <div className="custom-span not-closer"></div>+9
                            dorm
                          </label>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        "d-block content-field not-closer px-lg-4 pe-3 pe-lg-4 " +
                        (!openMaxBedrooms && "close")
                      }
                    >
                      <div
                        onClick={() => setOpenMaxBedrooms(!openMaxBedrooms)}
                        className="not-closer dropdown-select minimal-select btn btn-main no-hover "
                      >
                        {bedrooms.max === ""
                          ? "Máximo"
                          : (bedrooms.max.toString() === "99"
                              ? "+9"
                              : bedrooms.max) + " dorm"}
                        <i className="icon-arrow-light not-closer"></i>
                      </div>
                      <div className="not-closer float-select position-relative">
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkBedroom(
                              listDynamicFilters.data.objects,
                              1
                            ) ||
                              bedrooms.min > 1) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom("max", 1)}
                            checked={bedrooms.max.toString() === "1"}
                            type="radio"
                            id="bed-1-max"
                            name="bedMax"
                            value="1"
                          />
                          <label className="not-closer" htmlFor={"bed-1-max"}>
                            <div className="custom-span not-closer"></div>1 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkBedroom(
                              listDynamicFilters.data.objects,
                              2
                            ) ||
                              bedrooms.min > 2) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom("max", 2)}
                            checked={bedrooms.max.toString() === "2"}
                            type="radio"
                            id="bed-2-max"
                            name="bedMax"
                            value="2"
                          />
                          <label className="not-closer" htmlFor={"bed-2-max"}>
                            <div className="custom-span not-closer"></div>2 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkBedroom(
                              listDynamicFilters.data.objects,
                              3
                            ) ||
                              bedrooms.min > 3) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom("max", 3)}
                            checked={bedrooms.max.toString() === "3"}
                            type="radio"
                            id="bed-3-max"
                            name="bedMax"
                            value="3"
                          />
                          <label className="not-closer" htmlFor={"bed-3-max"}>
                            <div className="custom-span not-closer"></div>3 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkBedroom(
                              listDynamicFilters.data.objects,
                              4
                            ) ||
                              bedrooms.min > 4) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom("max", 4)}
                            checked={bedrooms.max.toString() === "4"}
                            type="radio"
                            id="bed-4-max"
                            name="bedMax"
                            value="4"
                          />
                          <label className="not-closer" htmlFor={"bed-4-max"}>
                            <div className="custom-span not-closer"></div>4 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkBedroom(
                              listDynamicFilters.data.objects,
                              5
                            ) ||
                              bedrooms.min > 5) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom("max", 5)}
                            checked={bedrooms.max.toString() === "5"}
                            type="radio"
                            id="bed-5-max"
                            name="bedMax"
                            value="5"
                          />
                          <label className="not-closer" htmlFor={"bed-5-max"}>
                            <div className="custom-span not-closer"></div>5 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkBedroom(
                              listDynamicFilters.data.objects,
                              6
                            ) ||
                              bedrooms.min > 6) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom("max", 6)}
                            checked={bedrooms.max.toString() === "6"}
                            id="bed-6-max"
                            name="bedMax"
                            value="6"
                          />
                          <label className="not-closer" htmlFor={"bed-6-max"}>
                            <div className="custom-span not-closer"></div>6 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkBedroom(
                              listDynamicFilters.data.objects,
                              7
                            ) ||
                              bedrooms.min > 7) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom("max", 7)}
                            checked={bedrooms.max.toString() === "7"}
                            id="bed-7-max"
                            name="bedMax"
                            value="7"
                          />
                          <label className="not-closer" htmlFor={"bed-7-max"}>
                            <div className="custom-span not-closer"></div>7 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkBedroom(
                              listDynamicFilters.data.objects,
                              8
                            ) ||
                              bedrooms.min > 8) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom("max", 8)}
                            checked={bedrooms.max.toString() === "8"}
                            id="bed-8-max"
                            name="bedMax"
                            value="8"
                          />
                          <label className="not-closer" htmlFor={"bed-8-max"}>
                            <div className="custom-span not-closer"></div>8 dorm
                          </label>
                        </div>
                        <div
                          className={
                            "not-closer flex-input " +
                            ((!checkBedroom(
                              listDynamicFilters.data.objects,
                              9
                            ) ||
                              bedrooms.min > 9) &&
                              "d-none")
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom("max", 99)}
                            checked={bedrooms.max.toString() === "99"}
                            id="bed-9-max"
                            name="bedMax"
                            value="9"
                          />
                          <label className="not-closer" htmlFor={"bed-9-max"}>
                            <div className="custom-span not-closer"></div>+9
                            dorm
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={"filters-group "} id="age">
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer  collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-age"
              aria-expanded="false"
              aria-controls="collapse-age"
            >
              Antigüedad <a className="icon-arrow text-right d-block"></a>
            </h3>
            <div className="options">
              <div className="row collapse pb-4" id="collapse-age">
                <div className={"col-lg-4 "}>
                  <label className={"option me-5 "}>
                    <input
                      onChange={() =>
                        updateFilters(
                          setFilters,
                          filters,
                          "age",
                          "En construcción"
                        )
                      }
                      checked={checkCurrentFilters(
                        filters,
                        "age",
                        "En construcción"
                      )}
                      type="radio"
                      id="age-filter-1"
                      name="age"
                      value="-1"
                    />
                    <span
                      className=""
                      style={{ borderRadius: "100%", overflow: "hidden" }}
                    ></span>
                    En construcción
                  </label>
                </div>
                <div className={"col-lg-4 "}>
                  <label className={"option me-5 "}>
                    <input
                      onChange={() =>
                        updateFilters(setFilters, filters, "age", "A estrenar")
                      }
                      checked={checkCurrentFilters(
                        filters,
                        "age",
                        "A estrenar"
                      )}
                      type="radio"
                      id="age-filter-2"
                      name="age"
                      value="0"
                    />
                    <span
                      className=""
                      style={{ borderRadius: "100%", overflow: "hidden" }}
                    ></span>
                    A estrenar
                  </label>
                </div>
                <div className={"col-lg-4 "}>
                  <label className={"option me-5 "}>
                    <input
                      onChange={() =>
                        updateFilters(setFilters, filters, "age", "1 a 5 años")
                      }
                      checked={checkCurrentFilters(
                        filters,
                        "age",
                        "1 a 5 años"
                      )}
                      type="radio"
                      id="age-filter-3"
                      name="age"
                      value="0"
                    />
                    <span
                      className=""
                      style={{ borderRadius: "100%", overflow: "hidden" }}
                    ></span>
                    1 a 5 años
                  </label>
                </div>
                <div className={"col-lg-4 "}>
                  <label className={"option me-5 "}>
                    <input
                      onChange={() =>
                        updateFilters(setFilters, filters, "age", "6 a 10 años")
                      }
                      checked={checkCurrentFilters(
                        filters,
                        "age",
                        "6 a 10 años"
                      )}
                      type="radio"
                      id="age-filter-4"
                      name="age"
                      value="0"
                    />
                    <span
                      className=""
                      style={{ borderRadius: "100%", overflow: "hidden" }}
                    ></span>
                    6 a 10 años
                  </label>
                </div>
                <div className={"col-lg-4 "}>
                  <label className={"option me-5 "}>
                    <input
                      onChange={() =>
                        updateFilters(
                          setFilters,
                          filters,
                          "age",
                          "11 a 20 años"
                        )
                      }
                      checked={checkCurrentFilters(
                        filters,
                        "age",
                        "11 a 20 años"
                      )}
                      type="radio"
                      id="age-filter-5"
                      name="age"
                      value="0"
                    />
                    <span
                      className=""
                      style={{ borderRadius: "100%", overflow: "hidden" }}
                    ></span>
                    11 a 20 años
                  </label>
                </div>
                <div className={"col-lg-4 "}>
                  <label className={"option me-5 "}>
                    <input
                      onChange={() =>
                        updateFilters(
                          setFilters,
                          filters,
                          "age",
                          "21 a 50 años"
                        )
                      }
                      checked={checkCurrentFilters(
                        filters,
                        "age",
                        "21 a 50 años"
                      )}
                      type="radio"
                      id="age-filter-6"
                      name="age"
                      value="0"
                    />
                    <span
                      className=""
                      style={{ borderRadius: "100%", overflow: "hidden" }}
                    ></span>
                    21 a 50 años
                  </label>
                </div>
                <div className={"col-lg-4 "}>
                  <label className={"option me-5 "}>
                    <input
                      onChange={() =>
                        updateFilters(setFilters, filters, "age", "+ 50 años")
                      }
                      checked={checkCurrentFilters(filters, "age", "+ 50 años")}
                      type="radio"
                      id="age-filter-7"
                      name="age"
                      value="0"
                    />
                    <span
                      className=""
                      style={{ borderRadius: "100%", overflow: "hidden" }}
                    ></span>
                    + 50 años
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="filters-group">
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer  collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-price"
              aria-expanded="false"
              aria-controls="collapse-price"
            >
              Precio <a className="icon-arrow text-right d-block"></a>
            </h3>

            <div className="collapse m-0 row" id="collapse-price">
              <div className={"options " + (!lowPrice && "d-none")}>
                <label className="option me-3 d-inline">
                  <input
                    type="checkbox"
                    className="d-none"
                    onChange={() =>
                      updateFilters(setFilters, filters, "is_off", true)
                    }
                    checked={checkCurrentFilters(filters, "is_off", true)}
                    id={"is_off"}
                    name={"is_off"}
                  />
                  <span className="square"></span>Propiedades retasadas
                </label>
              </div>
              <div className="col-12 div_subtitle_collapse">
                <div
                  className={
                    "col-lg-12 mb-4 mt-2 " +
                    (!auxiliarValuesPrice.priceType ? " " : "d-none")
                  }
                >
                  <span className="text-danger">
                    Primero debes seleccionar un tipo de moneda.
                  </span>
                </div>
              </div>
              <div className="col-12">
                <div className="row">
                  <div
                    id="moneda"
                    className="options col-12 col-lg-4 d-block pt-3 pb-4"
                  >
                    <label className="option me-5 d-inline">
                      <input
                        onClick={() =>
                          setAuxiliarPrice({
                            ...auxiliarValuesPrice,
                            priceType: "pesos",
                          })
                        }
                        checked={
                          auxiliarValuesPrice.priceType.toLowerCase() ===
                          "pesos"
                        }
                        type="checkbox"
                        id="peso"
                        name="currency"
                        value="ARS"
                      />
                      <span className="radio"></span>Pesos
                    </label>
                    <label className="option d-inline">
                      <input
                        onClick={() =>
                          setAuxiliarPrice({
                            ...auxiliarValuesPrice,
                            priceType: "dolares",
                          })
                        }
                        checked={
                          auxiliarValuesPrice.priceType.toLowerCase() ===
                          "dolares"
                        }
                        type="radio"
                        id="dolar"
                        name="currency"
                        value="USD"
                      />
                      <span className="radio"></span>Dólares
                    </label>
                  </div>
                  <div className="options my-2 my-lg-0 pb-4 col-12 col-lg-8 align-self-center">
                    <div className="row">
                      <div className="col-6 col-lg-4">
                        <input
                          type="text"
                          placeholder="Desde"
                          disabled={!auxiliarValuesPrice.priceType}
                          onFocus={() =>
                            setHelpers({ ...helpers, minprice: 1 })
                          }
                          onChange={e =>
                            setAuxiliarPrice({
                              ...auxiliarValuesPrice,
                              priceMin: e.target.value,
                            })
                          }
                          value={auxiliarValuesPrice.priceMin}
                        />
                        <div
                          className={
                            "cursor-pointer price-helper " +
                            (helpers.minprice ? "" : "d-none")
                          }
                        >
                          {pricesDefault.map((price, index) => (
                            <div
                              onClick={() =>
                                setAuxiliarPrice({
                                  ...auxiliarValuesPrice,
                                  priceMin: price,
                                }) + setHelpers({ ...helpers, minprice: 0 })
                              }
                              key={index}
                              className="price-helper-item"
                            >
                              {Intl.NumberFormat("de-DE").format(price)}
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="col-6 col-lg-4">
                        <input
                          type="text"
                          disabled={!auxiliarValuesPrice.priceType}
                          placeholder="Hasta"
                          onFocus={() =>
                            setHelpers({ ...helpers, maxprice: 1 })
                          }
                          onChange={e =>
                            setAuxiliarPrice({
                              ...auxiliarValuesPrice,
                              priceMax: e.target.value,
                            })
                          }
                          value={auxiliarValuesPrice.priceMax}
                        />
                        <div
                          className={
                            "cursor-pointer price-helper " +
                            (helpers.maxprice ? "" : "d-none")
                          }
                        >
                          {pricesDefault.map((price, index) =>
                            price > auxiliarValuesPrice.priceMin ? (
                              <div
                                onClick={() =>
                                  setAuxiliarPrice({
                                    ...auxiliarValuesPrice,
                                    priceMax: price,
                                  }) + setHelpers({ ...helpers, maxprice: 0 })
                                }
                                key={index}
                                className="price-helper-item"
                              >
                                {Intl.NumberFormat("de-DE").format(price)}
                              </div>
                            ) : null
                          )}
                        </div>
                      </div>
                      <div
                        className="btn btn-blue mt-4 mt-lg-0 col-12 col-lg-3 m-auto"
                        onClick={() => sendAuxiliar()}
                      >
                        Aplicar
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="filters-group">
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer  collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-sup"
              aria-expanded="false"
              aria-controls="collapse-sup"
            >
              Superficie <a className="icon-arrow text-right d-block"></a>
            </h3>
            <div className="collapse m-0 row " id="collapse-sup">
              <div className="col-12 div_subtitle_collapse">
                <div
                  className={
                    "col-lg-12 mb-4 " +
                    (!auxiliarValuesSurface.surfaceType ? " " : "d-none")
                  }
                >
                  <span className="text-danger">
                    Primero debes seleccionar un tipo de superficie.
                  </span>
                </div>
              </div>
              <div className="col-12">
                <div className="row">
                  <div
                    id="moneda"
                    className="options col-12 col-lg-4 d-block pt-3 pb-4"
                  >
                    <label className="option me-5 d-inline">
                      <input
                        onClick={() =>
                          setAuxiliarSurface({
                            ...auxiliarValuesSurface,
                            surfaceType: "cubierta",
                          })
                        }
                        checked={
                          auxiliarValuesSurface.surfaceType === "cubierta"
                        }
                        type="radio"
                        id="peso"
                        name="surface_type"
                        value="ARS"
                      />
                      <span className="radio"></span>Cubierta
                    </label>
                    <label className="option d-inline">
                      <input
                        onClick={() =>
                          setAuxiliarSurface({
                            ...auxiliarValuesSurface,
                            surfaceType: "total",
                          })
                        }
                        checked={auxiliarValuesSurface.surfaceType === "total"}
                        type="radio"
                        id="dolar"
                        name="surface_type"
                        value="USD"
                      />
                      <span className="radio"></span>Total
                    </label>
                  </div>
                  <div className="options my-2 my-lg-0 pb-4 col-12 col-lg-8 align-self-center">
                    <div className="row">
                      <div className="col-6 col-lg-4">
                        <input
                          type="text"
                          placeholder="Desde"
                          disabled={!auxiliarValuesSurface.surfaceType}
                          onChange={e =>
                            setAuxiliarSurface({
                              ...auxiliarValuesSurface,
                              surfaceMin: e.target.value,
                            })
                          }
                          value={auxiliarValuesSurface.surfaceMin}
                        />
                      </div>
                      <div className="col-6 col-lg-4">
                        <input
                          type="text"
                          placeholder="Hasta"
                          disabled={!auxiliarValuesSurface.surfaceType}
                          onChange={e =>
                            setAuxiliarSurface({
                              ...auxiliarValuesSurface,
                              surfaceMax: e.target.value,
                            })
                          }
                          value={auxiliarValuesSurface.surfaceMax}
                        />
                      </div>
                      <div
                        className="btn btn-blue mt-4 mt-lg-0 col-12 col-lg-3 m-auto"
                        onClick={() => sendAuxiliar()}
                      >
                        Aplicar
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              "filters-group " +
              (listDynamicFilters?.data?.objects?.tags.filter(
                element => element.tag_type === 3
              )?.length === 0
                ? "d-none"
                : "")
            }
            id="types_environments"
          >
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer  collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapsetypes"
              aria-expanded="false"
              aria-controls="collapsetypes"
            >
              Tipos de ambientes{" "}
              <a className="icon-arrow text-right d-block"></a>
            </h3>
            <div className="options pb-4 collapse  " id="collapsetypes">
              <div className="row">
                {getEnvironment(listDynamicFilters.data.objects).map(
                  (environment, index) => (
                    <div
                      key={index}
                      className={
                        "col-lg-4 " +
                        (getTagCount(
                          listDynamicFilters.data.objects,
                          environment
                        ) === 0
                          ? "d-none"
                          : "")
                      }
                    >
                      <label
                        className={
                          "option " +
                          (getTagCount(
                            listDynamicFilters.data.objects,
                            environment
                          ) === 0
                            ? "opacity-filter"
                            : "")
                        }
                      >
                        <input
                          onChange={() =>
                            updateFilters(
                              setFilters,
                              filters,
                              "environments_types",
                              {
                                id: environment.tag_id,
                                name: environment.tag_name,
                              }
                            )
                          }
                          checked={checkCurrentFilters(
                            filters,
                            "environments_types",
                            {
                              id: environment.tag_id,
                              name: environment.tag_name,
                            }
                          )}
                          type="checkbox"
                          id={"roomtype-" + environment.tag_id}
                          name="roomtypes[]"
                          value={environment}
                        />
                        <span className="square"></span>
                        {environment.tag_name}
                      </label>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
          <div
            className={
              "filters-group " +
              (listDynamicFilters?.data?.objects?.tags.filter(
                element => element.tag_type === 3
              )?.length === 0
                ? "d-none"
                : "")
            }
            id="generals"
          >
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer  collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapseamenities"
              aria-expanded="false"
              aria-controls="collapseamenities"
            >
              Generales <a className="icon-arrow text-right d-block"></a>
            </h3>
            <div className="options pb-4 collapse  " id="collapseamenities">
              <div className="row">
                {getGenerals(listDynamicFilters.data.objects).map(
                  (generals, index) => (
                    <div
                      key={index}
                      className={
                        "col-lg-4 " +
                        (getTagCount(
                          listDynamicFilters.data.objects,
                          generals
                        ) === 0
                          ? "d-none"
                          : "")
                      }
                    >
                      <label
                        className={
                          "option " +
                          (getTagCount(
                            listDynamicFilters.data.objects,
                            generals
                          ) === 0
                            ? "opacity-filter"
                            : "")
                        }
                      >
                        <input
                          onChange={() =>
                            updateFilters(setFilters, filters, "generals", {
                              id: generals.tag_id,
                              name: generals.tag_name,
                            })
                          }
                          checked={checkCurrentFilters(filters, "generals", {
                            id: generals.tag_id,
                            name: generals.tag_name,
                          })}
                          type="checkbox"
                          id={"amenities-" + generals.tag_id}
                          name="amenities[]"
                          value={generals}
                        />
                        <span className="square"></span>
                        {generals.tag_name}
                      </label>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
          <div
            className={
              "filters-group " +
              (listDynamicFilters?.data?.objects?.tags.filter(
                element => element.tag_type === 1
              )?.length === 0
                ? "d-none"
                : "")
            }
            id="services"
          >
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer  collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapseservice"
              aria-expanded="false"
              aria-controls="collapseservice"
            >
              Servicios <a className="icon-arrow text-right d-block"></a>
            </h3>
            <div className="options pb-4 collapse  " id="collapseservice">
              <div className="row pb-lg-0">
                {getServices(listDynamicFilters.data.objects).map(
                  (services, index) => (
                    <div
                      className={
                        "col-lg-4 " +
                        +(getTagCount(
                          listDynamicFilters.data.objects,
                          services
                        ) === 0
                          ? "d-none"
                          : "")
                      }
                    >
                      <label
                        className={
                          "option " +
                          (getTagCount(
                            listDynamicFilters.data.objects,
                            services
                          ) === 0
                            ? "opacity-filter"
                            : "")
                        }
                      >
                        <input
                          type="checkbox"
                          onChange={() =>
                            updateFilters(setFilters, filters, "services", {
                              id: services.tag_id,
                              name: services.tag_name,
                            })
                          }
                          checked={checkCurrentFilters(filters, "services", {
                            id: services.tag_id,
                            name: services.tag_name,
                          })}
                          id={"service-" + services.tag_id}
                          name="services[]"
                          value={services}
                        />
                        <span className="square"></span>
                        {services.tag_name}
                      </label>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
          {/* (getCustoms(custom_tags).filter(element => element.group_name === '' && element.count > 0) && 'd-none') */}
          {/* <div className={"filters-group " + (getCustoms(custom_tags)?.filter(element => element.group_name?.toLowerCase() === 'especiales' && element.count > 0).length === 0 && ' d-none ')} id="custom_tags"> */}
          <div className={"filters-group d-none "} id="custom_tags">
            <h3
              className="mb-4 d-flex align-items-center justify-content-between cursor-pointer  collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapsecustoms"
              aria-expanded="false"
              aria-controls="collapsecustoms"
            >
              Etiquetas especiales{" "}
              <a className="icon-arrow text-right d-block"></a>
            </h3>
            <div className="options pb-lg-5 collapse  " id="collapsecustoms">
              <div className="row pb-4 pb-lg-0">
                {getCustoms(custom_tags)?.map((custom, index) => (
                  // <div className={"col-lg-4 " + (custom.count === 0 || custom?.group_name?.toLowerCase() !== 'especiales' ? "d-none" : '')}>
                  <div
                    className={
                      "col-lg-4 " +
                      (custom.count === 0 ||
                      custom?.group_name?.toLowerCase() !== "especiales"
                        ? "d-none"
                        : "")
                    }
                  >
                    <label className={"option "}>
                      <input
                        type="checkbox"
                        onChange={() =>
                          updateFilters(
                            setFilters,
                            filters,
                            "specials",
                            makeCustom(custom)
                          )
                        }
                        checked={checkCurrentFilters(
                          filters,
                          "specials",
                          makeCustom(custom)
                        )}
                        id={"custom-" + custom.id}
                        name="specials[]"
                        value={custom}
                      />
                      {/* <input type="checkbox" name="customs[]" value={custom} /> */}
                      <span className="square"></span>
                      {custom.name} ({custom.count})
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-results">
          <input
            disabled={totalCount === 0}
            onClick={() =>
              document.body.classList.remove("overflow-hidden") + setMenu(false)
            }
            className="mx-auto d-block btn btn-blue btn-resultados"
            value={
              loading
                ? "Cargando..."
                : (totalCount > 0 ? "Ver " : "") + totalCount + " resultados"
            }
          />
        </div>
      </form>
    </aside>
  ) : (
    ""
  )
}

export default connect(
  state => ({
    _filters: state.properties.filters,
    offset: state.properties.offset,
    listLocationFilters: state.properties.listLocationFilters,
    loading_locations: state.properties.loading_locations,
    listDynamicFilters: state.properties.listDynamicFilters,
    loading_dynamic: state.properties.loading_dynamic,
    tokko_filters: state.properties.listFilters,
    total_tokko_filters: state.properties.totalListFilters,
    orders: state.properties.orders,
    api_key: state.settings.keys.tokko,
    totalCount: state.properties.totalCount,
    totalCountAlquiler: state.properties.totalCountAlquiler,
    totalCountVenta: state.properties.totalCountVenta,
    totalCountAlquilerTemporario: state.properties.totalCountAlquilerTemporario,
    loading: state.properties.loading,
    custom_tags: state.properties.custom_tags,
    polygonCoordinates: state.properties.polygonCoordinates,
    allLocations: state.properties.allLocationFilters,
    listLocationLite: state.properties.listLocationLite,
  }),
  null
)(Filter)
